import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ContactButtons from '../components/common/ContactButtons';
import SEO from '../components/common/SEO';
import { getCanonicalUrl } from '../utils/seoConstants';

/**
 * Временная заглушка для страницы бронирования
 * В данный момент функционал бронирования находится в разработке
 * Пользователям предлагается связаться с нами напрямую
 */
const BookingPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const widgetUrl = import.meta.env.VITE_BOOKING_WIDGET_URL || 'https://calendar72.com/widget/booking/fa53778c-5fb5-4c84-80e7-8610106c5e52';

  return (
    <>
      <SEO 
        title="Онлайн бронирование домика" 
        description="Онлайн бронирование домика в Domik72. Выберите даты и забронируйте удобное время через виджет календаря."
        canonicalUrl={getCanonicalUrl('/booking')}
      />
      <Box sx={{ py: 4, minHeight: '80vh' }}>
        <Container maxWidth="md">
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ mb: 3 }}
          >
            Назад
          </Button>
          
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom 
            align="center" 
            sx={{ mb: 4 }}
          >
            Бронирование
          </Typography>
          
          <Paper
            elevation={3}
            sx={{
              mx: 'auto',
              maxWidth: { xs: '95%', sm: '90%', md: '80%', lg: '70%' },
              px: { xs: 2, sm: 3, md: 4 },
              py: { xs: 3, sm: 4, md: 5 },
              position: 'relative',
              backgroundColor: theme => theme.palette.mode === 'dark' 
                ? 'rgba(30, 30, 30, 0.9)' 
                : 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
              borderRadius: '20px',
              boxShadow: theme => theme.palette.mode === 'dark'
                ? '0 4px 20px rgba(0, 0, 0, 0.3)'
                : '0 4px 20px rgba(0, 0, 0, 0.15)',
              border: theme => `1px solid ${theme.palette.divider}`
            }}
            >
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 700,
                  mb: 2,
                  color: theme => theme.palette.text.primary
                }}
              >
                Онлайн бронирование
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  mb: 3,
                  color: theme => theme.palette.text.secondary,
                  maxWidth: '700px',
                  mx: 'auto',
                  textAlign: 'justify'
                }}
              >
                Для оформления бронирования нажмите кнопку ниже, и откроется отдельная страница с онлайн виджетом календаря.
              </Typography>
            </Box>

            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Button
                variant="contained"
                color="primary"
                size={isSmall ? 'medium' : 'large'}
                component="a"
                href={widgetUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Открыть страницу бронирования
              </Button>
            </Box>

            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 700,
                  mb: 2,
                  color: theme => theme.palette.text.primary
                }}
              >
                Если у вас остались вопросы
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  mb: 2,
                  color: theme => theme.palette.text.secondary,
                  maxWidth: '600px',
                  mx: 'auto'
                }}
              >
                Вы можете связаться с нами любым удобным способом ниже.
              </Typography>
              <ContactButtons spacing={isSmall ? 5 : 8} />
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default BookingPage;
